import React, { useEffect, useRef, useState } from "react";
import {
  FaCss3Alt,
  FaDatabase,
  FaGithub,
  FaGitAlt,
  FaGitlab,
  FaHtml5,
  FaJs,
  FaPlug,
  FaPython,
  FaReact,
  FaTrello,
} from "react-icons/fa";
import {
  SiMongodb,
  SiMui,
  SiMqtt,
  SiMysql,
  SiTailwindcss,
} from "react-icons/si";

const Tecnologías = () => {
  const [visible, setVisible] = useState(false);
  const seccionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.15,
      }
    );

    if (seccionRef.current) {
      observer.observe(seccionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const categorias = [
    {
      nombre: "Desarrollo",
      items: [
        {
          nombre: "HTML",
          icono: FaHtml5,
          color: "text-[#E34F26]",
        },
        {
          nombre: "CSS",
          icono: FaCss3Alt,
          color: "text-[#1572B6]",
        },
        {
          nombre: "JavaScript",
          icono: FaJs,
          color: "text-[#F7DF1E]",
        },
        {
          nombre: "Python",
          icono: FaPython,
          color: "text-[#3776AB]",
        },
        {
          nombre: "React",
          icono: FaReact,
          color: "text-[#61DAFB]",
        },
        {
          nombre: "Tailwind CSS",
          icono: SiTailwindcss,
          color: "text-[#06B6D4]",
        },
        {
          nombre: "Material UI",
          icono: SiMui,
          color: "text-[#007FFF]",
        },
      ],
    },
    {
      nombre: "Bases de Datos",
      items: [
        {
          nombre: "MySQL",
          icono: SiMysql,
          color: "text-[#4479A1]",
        },
        {
          nombre: "MongoDB",
          icono: SiMongodb,
          color: "text-[#47A248]",
        },
        {
          nombre: "SQL Server",
          icono: FaDatabase,
          color: "text-[#CC2927]",
        },
      ],
    },
    {
      nombre: "Herramientas",
      items: [
        {
          nombre: "Git",
          icono: FaGitAlt,
          color: "text-[#F05032]",
        },
        {
          nombre: "GitHub",
          icono: FaGithub,
          color: "text-[#181717]",
        },
        {
          nombre: "GitLab",
          icono: FaGitlab,
          color: "text-[#FC6D26]",
        },
        {
          nombre: "Trello",
          icono: FaTrello,
          color: "text-[#0052CC]",
        },
      ],
    },
    {
      nombre: "Conocimientos",
      items: [
        {
          nombre: "Integración de APIs",
          icono: FaPlug,
          color: "text-[#000]",
        },
        {
          nombre: "MQTT",
          icono: SiMqtt,
          color: "text-[#660066]",
        },
      ],
    },
  ];

  const renderCategoria = (categoria, categoriaIndex) => (
    <div
      className={`tecnologia-animacion w-full ${
        visible ? "tecnologia-visible" : ""
      }`}
      style={{
        animationDelay: `${0.4 + categoriaIndex * 0.2}s`,
      }}
    >
      <h3 className="mb-6 text-center text-2xl font-bold text-[#1c2143]">
        {categoria.nombre}
      </h3>

      <div className="grid w-full grid-cols-2 gap-4 lg:flex">
        {categoria.items.map((item, index) => {
          const Icono = item.icono;

          const ultimaTarjeta =
            categoria.items.length % 2 !== 0 &&
            index === categoria.items.length - 1;

          return (
            <div
              key={item.nombre}
              className={`group tecnologia-animacion flex min-h-[120px] flex-col items-center justify-center rounded-2xl border-2 border-[#1c2143] bg-transparent px-3 py-4 text-center transition duration-300 hover:-translate-y-1 hover:bg-[#1c2143] hover:shadow-[0_0_40px_rgba(28,33,67,0.25)] sm:min-h-[150px] lg:col-span-1 lg:flex-1 ${
                ultimaTarjeta ? "col-span-2" : ""
              } ${visible ? "tecnologia-visible" : ""}`}
              style={{
                animationDelay: `${
                  0.6 + categoriaIndex * 0.2 + index * 0.08
                }s`,
              }}
            >
              <Icono
                className={`mb-2 text-6xl ${item.color} transition duration-300 group-hover:scale-110`}
              />

              <span className="text-base font-semibold leading-tight text-black transition duration-300 group-hover:text-white">
                {item.nombre}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <>
      <style>
        {`
          @keyframes aparecerDesdeAbajo {
            from {
              opacity: 0;
              transform: translateY(50px);
            }

            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .tecnologia-animacion {
            opacity: 0;
          }

          .tecnologia-visible {
            animation: aparecerDesdeAbajo 0.8s ease-out forwards;
          }

          @media (prefers-reduced-motion: reduce) {
            .tecnologia-animacion {
              opacity: 1;
            }

            .tecnologia-visible {
              animation: none;
            }
          }
        `}
      </style>

      <section
        ref={seccionRef}
        id="tecnologias"
        className="px-4 py-0 sm:px-6"
      >
        <div className="mx-auto max-w-[1230px] pb-20">
          <h2
            className={`tecnologia-animacion relative mb-5 text-center text-[35px] font-black text-[#1c2143] sm:text-[50px] ${
              visible ? "tecnologia-visible" : ""
            }`}
            style={{
              animationDelay: "0.1s",
            }}
          >
            Tecnologías

            <span className="mx-auto block h-1 w-[90px] rounded-full bg-[#1c2143] sm:w-[120px]" />
          </h2>

          <div className="grid gap-12">
            <div className="w-full lg:w-[1250px]">
              {renderCategoria(categorias[0], 0)}
            </div>

            <div className="flex flex-col gap-12 lg:flex-row lg:gap-16">
              <div className="w-full lg:w-[525px]">
                {renderCategoria(categorias[1], 1)}
              </div>

              <div className="w-full lg:w-[660px]">
                {renderCategoria(categorias[2], 2)}
              </div>
            </div>

            <div className="mx-auto w-full lg:w-[440px]">
              {renderCategoria(categorias[3], 3)}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Tecnologías;